import React from "react";
import { MdFilterListOff } from "react-icons/md";

const DepenseFilters = ({ filters, onFilterChange, onResetFilters }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ [name]: value === "" ? null : value });
  };

  return (
    <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-medium text-gray-700">Filtres avancés</h3>
        <button
          onClick={onResetFilters}
          className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900"
        >
          <MdFilterListOff className="h-4 w-4" />
          <span>Réinitialiser</span>
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4">
        <div>
          <label htmlFor="dateStart" className="block text-xs font-medium text-gray-700">
            Date début
          </label>
          <input
            type="date"
            id="dateStart"
            name="dateStart"
            value={filters.dateStart || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
          />
        </div>
        <div>
          <label htmlFor="dateEnd" className="block text-xs font-medium text-gray-700">
            Date fin
          </label>
          <input
            type="date"
            id="dateEnd"
            name="dateEnd"
            value={filters.dateEnd || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
          />
        </div>
        <div>
          <label htmlFor="minAmount" className="block text-xs font-medium text-gray-700">
            Montant minimum (MGA)
          </label>
          <input
            type="number"
            id="minAmount"
            name="minAmount"
            value={filters.minAmount || ""}
            onChange={handleInputChange}
            placeholder="Ex: 10000"
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
          />
        </div>
        <div>
          <label htmlFor="maxAmount" className="block text-xs font-medium text-gray-700">
            Montant maximum (MGA)
          </label>
          <input
            type="number"
            id="maxAmount"
            name="maxAmount"
            value={filters.maxAmount || ""}
            onChange={handleInputChange}
            placeholder="Ex: 50000"
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-[#57A863] focus:outline-none focus:ring-[#57A863]"
          />
        </div>
      </div>
    </div>
  );
};

export default DepenseFilters;